import { LINE } from '@/configs/app.config'

const ShareAdapter = {
  getParamsFromConfig(currentConfiguration: InputVariantType) {
    // TODO: Get partner code from query params
    const queriesParams = new URLSearchParams(window.location.search)
    const partnerCode = queriesParams.get('partnercode') ?? ''

    // TODO: Build params
    const params = new URLSearchParams()
    params.append('modelName', currentConfiguration?.modelName ?? '')
    params.append('frameColor', currentConfiguration?.frameColor ?? '')
    params.append('templeColor', currentConfiguration?.templeColor ?? '')
    params.append('lensColor', currentConfiguration?.lensColor ?? '')
    params.append('lensOptions', currentConfiguration?.lensOptions?.join(',') ?? '')
    params.append('logoFrontColor', currentConfiguration?.logoFrontColor ?? '')
    params.append('logoBackColor', currentConfiguration?.logoBackColor ?? '')
    params.append('bridgeName', currentConfiguration?.bridgeName ?? '')
    params.append('thumbnailUrl', currentConfiguration?.thumbnailUrl ?? '')
    params.append('openExternalBrowser', '1')
    params.append('partnercode', partnerCode)

    return params
  },

  transformShareByLine(currentConfiguration: InputVariantType) {
    const rootUri = `https://line.me/R/oaMessage/${LINE.account}/`
    const messageTemplate = encodeURIComponent('【購入希望】\n*本メッセージ送信後にオペレータよりご案内させていただきますので、そのまま送信いただきお待ちくださいませ\n\n')
    const params = this.getParamsFromConfig(currentConfiguration)
    const fullPath = `${rootUri}?${messageTemplate}${LINE.uri}?${params}`
    return fullPath
  },

  transformShareByURL(currentConfiguration: InputVariantType) {
    const params = this.getParamsFromConfig(currentConfiguration)
    return `${LINE.uri}?${params}`
  },
}

export default ShareAdapter
